(function() {
  const SWIPE_THRESHOLD = 30;

  function setupSwipeForElement(carouselEl) {
    if (!carouselEl || carouselEl.dataset.touchSwipeInit === 'true') return;

    let startX = 0;
    let startY = 0;

    carouselEl.addEventListener('touchstart', function(event) {
      if (!event.touches || !event.touches.length) return;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    carouselEl.addEventListener('touchend', function(event) {
      if (!event.changedTouches || !event.changedTouches.length) return;

      const endX = event.changedTouches[0].clientX;
      const endY = event.changedTouches[0].clientY;
      const deltaX = endX - startX;
      const deltaY = endY - startY;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) <= Math.abs(deltaY)) {
        return;
      }

      if (carouselEl.tagName === 'SCROLL-CAROUSEL') {
        if (deltaX < 0 && typeof carouselEl.next === 'function') {
          carouselEl.next();
        } else if (deltaX > 0 && typeof carouselEl.previous === 'function') {
          carouselEl.previous();
        }
      } else {
        carouselEl.scrollBy({
          left: deltaX < 0 ? carouselEl.clientWidth : -carouselEl.clientWidth,
          behavior: 'smooth'
        });
      }
    }, { passive: true });

    carouselEl.dataset.touchSwipeInit = 'true';
  }

  function setupCartDrawerSwipe() {
    document.querySelectorAll('.cart-drawer .complementary-products__product-list--carousel').forEach(setupSwipeForElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartDrawerSwipe);
  } else {
    setupCartDrawerSwipe();
  }

  document.addEventListener('cart-drawer:refreshed', setupCartDrawerSwipe);
})();
